// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Reports Page + Report Table
   ============================================ */

.rpg-container {
  max-width: 1100px;
  margin: 0 auto;
}

.rpg-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.rpg-title-wrap {
  display: flex;
  align-items: center;
  gap: 0.9rem;
}

.rpg-title-icon {
  width: 44px;
  height: 44px;
  border-radius: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #F0FDF4, #CCFBF1);
  color: #0F766E;
  border: 1px solid #99F6E4;
}

.rpg-title {
  font-size: 1.375rem;
  font-weight: 700;
  color: #0F172A;
  letter-spacing: -0.3px;
}

.rpg-sub {
  font-size: 0.875rem;
  color: #64748B;
}

.rpg-refresh {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.55rem 1rem;
  background: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 0.625rem;
  color: #475569;
  font-family: inherit;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.rpg-refresh:hover {
  border-color: #0F766E;
  color: #0F766E;
  background: #F0FDF4;
}

.rpg-error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #FEF2F2;
  border: 1px solid #FECACA;
  color: #DC2626;
  padding: 0.75rem 1rem;
  border-radius: 0.625rem;
  font-size: 0.8125rem;
  font-weight: 500;
  margin-bottom: 1rem;
}

.rpg-toolbar {
  margin-bottom: 1rem;
}

.rpg-search {
  position: relative;
  max-width: 340px;
}

.rpg-search-icon {
  position: absolute;
  left: 0.85rem;
  top: 50%;
  transform: translateY(-50%);
  color: #94A3B8;
}

.rpg-search input {
  width: 100%;
  padding: 0.65rem 1rem 0.65rem 2.4rem;
  border: 1.5px solid #E2E8F0;
  border-radius: 0.625rem;
  background: #fff;
  font-family: inherit;
  font-size: 0.875rem;
  color: #0F172A;
  outline: none;
  transition: border-color 0.2s;
}

.rpg-search input:focus {
  border-color: #0F766E;
}

.rpg-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 3rem 0;
  color: #64748B;
  font-size: 0.875rem;
}

.rpg-spinner {
  width: 28px;
  height: 28px;
  border: 3px solid #E2E8F0;
  border-top-color: #0F766E;
  border-radius: 50%;
  animation: rpgSpin 0.8s linear infinite;
}

@keyframes rpgSpin {
  to { transform: rotate(360deg); }
}

.rpg-notice {
  position: fixed;
  bottom: 1.5rem;
  right: 1.5rem;
  z-index: 1100;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #fff;
  border: 1px solid #BBF7D0;
  color: #047857;
  padding: 0.75rem 1rem;
  border-radius: 0.625rem;
  font-size: 0.8125rem;
  font-weight: 500;
  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.2);
}

.rpg-notice-error {
  border-color: #FECACA;
  color: #DC2626;
  background: #FEF2F2;
}

/* Report table */
.rpt-wrap {
  background: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 0.875rem;
  overflow: hidden;
}

.rpt-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.rpt-table th {
  text-align: left;
  padding: 0.8rem 1rem;
  background: #F8FAFC;
  border-bottom: 1px solid #E2E8F0;
  color: #64748B;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
}

.rpt-table td {
  padding: 0.85rem 1rem;
  border-bottom: 1px solid #F1F5F9;
  color: #334155;
  vertical-align: middle;
}

.rpt-table tbody tr:last-child td {
  border-bottom: none;
}

.rpt-table tbody tr {
  transition: background 0.15s ease;
}

.rpt-table tbody tr:hover {
  background: #F8FAFC;
}

.rpt-name {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  font-weight: 600;
  color: #0F172A;
}

.rpt-avatar {
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #F0FDF4, #CCFBF1);
  color: #0F766E;
  font-weight: 700;
  font-size: 0.8125rem;
}

.rpt-name-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rpt-sortable {
  cursor: pointer;
}

.rpt-sortable:hover {
  color: #0F766E;
}

.rpt-sort-label {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.rpt-sort-val {
  font-size: 0.8125rem;
  color: #94A3B8;
}

.rpt-status {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.25rem 0.7rem;
  background: #F0FDF4;
  border: 1px solid #BBF7D0;
  color: #047857;
  border-radius: 2rem;
  font-size: 0.75rem;
  font-weight: 600;
}

.rpt-status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #059669;
}

.rpt-actions-col {
  text-align: right;
}

.rpt-actions {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
}

.rpt-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.45rem 0.75rem;
  border: 1px solid #E2E8F0;
  background: #fff;
  color: #475569;
  border-radius: 0.5rem;
  font-family: inherit;
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.rpt-btn:hover {
  border-color: #0F766E;
  color: #0F766E;
  background: #F0FDF4;
}

.rpt-btn-download:hover {
  border-color: #0D9488;
  background: #F0FDF4;
}

.rpt-empty {
  text-align: center;
  color: #94A3B8;
  padding: 3rem 1rem;
  font-size: 0.875rem;
}

.rpt-empty span {
  display: block;
  margin-top: 0.5rem;
}

/* Detail modal */
.rpg-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  animation: rpgFadeIn 0.25s ease;
}

.rpg-detail {
  position: relative;
  width: 100%;
  max-width: 640px;
  max-height: 90vh;
  overflow-y: auto;
  background: #fff;
  border-radius: 1.25rem;
  border: 1px solid #E2E8F0;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  padding: 1.75rem;
  animation: rpgSlideUp 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.rpg-detail-close {
  position: absolute;
  top: 0.9rem;
  right: 0.9rem;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #F1F5F9;
  border: 1px solid #E2E8F0;
  border-radius: 0.5rem;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s ease;
}

.rpg-detail-close:hover {
  background: #FEF2F2;
  border-color: #FECACA;
  color: #DC2626;
}

.rpg-detail-header {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  padding-right: 2.5rem;
  margin-bottom: 1.25rem;
  flex-wrap: wrap;
}

.rpg-detail-icon {
  width: 48px;
  height: 48px;
  min-width: 48px;
  border-radius: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #F0FDF4, #CCFBF1);
  color: #0F766E;
  border: 1px solid #99F6E4;
}

.rpg-detail-name {
  font-size: 1.125rem;
  font-weight: 700;
  color: #0F172A;
}

.rpg-detail-meta {
  font-size: 0.8125rem;
  color: #64748B;
}

.rpg-detail-download {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.55rem 1rem;
  background: linear-gradient(135deg, #0F766E, #0D9488);
  color: #fff;
  border: none;
  border-radius: 0.625rem;
  font-family: inherit;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.15s;
  box-shadow: 0 4px 14px rgba(15, 118, 110, 0.3);
}

.rpg-detail-download:hover {
  opacity: 0.92;
  transform: translateY(-1px);
}

.rpg-detail-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  padding: 2rem 0;
  color: #64748B;
  font-size: 0.875rem;
}

.rpg-detail-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.75rem;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 0.75rem;
  padding: 1rem;
  margin-bottom: 1.25rem;
}

.rpg-info-item {
  display: flex;
  align-items: flex-start;
  gap: 0.6rem;
  color: #0F766E;
}

.rpg-info-label {
  font-size: 0.6875rem;
  font-weight: 600;
  color: #94A3B8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.rpg-info-val {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #0F172A;
  margin-top: 0.1rem;
}

.rpg-detail-section-title {
  font-size: 0.875rem;
  font-weight: 700;
  color: #0F172A;
  margin-bottom: 0.75rem;
}

.rpg-vitals-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 0.75rem;
}

.rpg-vital-item {
  background: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 0.625rem;
  padding: 0.7rem 0.9rem;
}

.rpg-vital-label {
  font-size: 0.6875rem;
  font-weight: 600;
  color: #94A3B8;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 0.2rem;
}

.rpg-vital-value {
  font-size: 1rem;
  font-weight: 700;
  color: #0F172A;
}

.rpg-no-vitals {
  color: #94A3B8;
  font-size: 0.8125rem;
}

@keyframes rpgFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes rpgSlideUp {
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
}
`, "",{"version":3,"sources":["webpack://./src/component/ReportsPage.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iDAAiD;EACjD,gBAAgB;EAChB,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;EACrD,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,qDAAqD;EACrD,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C","sourcesContent":["/* ============================================\r\n   Reports Page + Report Table\r\n   ============================================ */\r\n\r\n.rpg-container {\r\n  max-width: 1100px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.rpg-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.rpg-title-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.9rem;\r\n}\r\n\r\n.rpg-title-icon {\r\n  width: 44px;\r\n  height: 44px;\r\n  border-radius: 0.875rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: linear-gradient(135deg, #F0FDF4, #CCFBF1);\r\n  color: #0F766E;\r\n  border: 1px solid #99F6E4;\r\n}\r\n\r\n.rpg-title {\r\n  font-size: 1.375rem;\r\n  font-weight: 700;\r\n  color: #0F172A;\r\n  letter-spacing: -0.3px;\r\n}\r\n\r\n.rpg-sub {\r\n  font-size: 0.875rem;\r\n  color: #64748B;\r\n}\r\n\r\n.rpg-refresh {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.45rem;\r\n  padding: 0.55rem 1rem;\r\n  background: #fff;\r\n  border: 1px solid #E2E8F0;\r\n  border-radius: 0.625rem;\r\n  color: #475569;\r\n  font-family: inherit;\r\n  font-size: 0.8125rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.rpg-refresh:hover {\r\n  border-color: #0F766E;\r\n  color: #0F766E;\r\n  background: #F0FDF4;\r\n}\r\n\r\n.rpg-error {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  background: #FEF2F2;\r\n  border: 1px solid #FECACA;\r\n  color: #DC2626;\r\n  padding: 0.75rem 1rem;\r\n  border-radius: 0.625rem;\r\n  font-size: 0.8125rem;\r\n  font-weight: 500;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.rpg-toolbar {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.rpg-search {\r\n  position: relative;\r\n  max-width: 340px;\r\n}\r\n\r\n.rpg-search-icon {\r\n  position: absolute;\r\n  left: 0.85rem;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: #94A3B8;\r\n}\r\n\r\n.rpg-search input {\r\n  width: 100%;\r\n  padding: 0.65rem 1rem 0.65rem 2.4rem;\r\n  border: 1.5px solid #E2E8F0;\r\n  border-radius: 0.625rem;\r\n  background: #fff;\r\n  font-family: inherit;\r\n  font-size: 0.875rem;\r\n  color: #0F172A;\r\n  outline: none;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.rpg-search input:focus {\r\n  border-color: #0F766E;\r\n}\r\n\r\n.rpg-loading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  padding: 3rem 0;\r\n  color: #64748B;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.rpg-spinner {\r\n  width: 28px;\r\n  height: 28px;\r\n  border: 3px solid #E2E8F0;\r\n  border-top-color: #0F766E;\r\n  border-radius: 50%;\r\n  animation: rpgSpin 0.8s linear infinite;\r\n}\r\n\r\n@keyframes rpgSpin {\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n.rpg-notice {\r\n  position: fixed;\r\n  bottom: 1.5rem;\r\n  right: 1.5rem;\r\n  z-index: 1100;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  background: #fff;\r\n  border: 1px solid #BBF7D0;\r\n  color: #047857;\r\n  padding: 0.75rem 1rem;\r\n  border-radius: 0.625rem;\r\n  font-size: 0.8125rem;\r\n  font-weight: 500;\r\n  box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.rpg-notice-error {\r\n  border-color: #FECACA;\r\n  color: #DC2626;\r\n  background: #FEF2F2;\r\n}\r\n\r\n/* Report table */\r\n.rpt-wrap {\r\n  background: #fff;\r\n  border: 1px solid #E2E8F0;\r\n  border-radius: 0.875rem;\r\n  overflow: hidden;\r\n}\r\n\r\n.rpt-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.rpt-table th {\r\n  text-align: left;\r\n  padding: 0.8rem 1rem;\r\n  background: #F8FAFC;\r\n  border-bottom: 1px solid #E2E8F0;\r\n  color: #64748B;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  white-space: nowrap;\r\n}\r\n\r\n.rpt-table td {\r\n  padding: 0.85rem 1rem;\r\n  border-bottom: 1px solid #F1F5F9;\r\n  color: #334155;\r\n  vertical-align: middle;\r\n}\r\n\r\n.rpt-table tbody tr:last-child td {\r\n  border-bottom: none;\r\n}\r\n\r\n.rpt-table tbody tr {\r\n  transition: background 0.15s ease;\r\n}\r\n\r\n.rpt-table tbody tr:hover {\r\n  background: #F8FAFC;\r\n}\r\n\r\n.rpt-name {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.65rem;\r\n  font-weight: 600;\r\n  color: #0F172A;\r\n}\r\n\r\n.rpt-avatar {\r\n  width: 32px;\r\n  height: 32px;\r\n  min-width: 32px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: linear-gradient(135deg, #F0FDF4, #CCFBF1);\r\n  color: #0F766E;\r\n  font-weight: 700;\r\n  font-size: 0.8125rem;\r\n}\r\n\r\n.rpt-name-text {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.rpt-sortable {\r\n  cursor: pointer;\r\n}\r\n\r\n.rpt-sortable:hover {\r\n  color: #0F766E;\r\n}\r\n\r\n.rpt-sort-label {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n}\r\n\r\n.rpt-sort-val {\r\n  font-size: 0.8125rem;\r\n  color: #94A3B8;\r\n}\r\n\r\n.rpt-status {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  padding: 0.25rem 0.7rem;\r\n  background: #F0FDF4;\r\n  border: 1px solid #BBF7D0;\r\n  color: #047857;\r\n  border-radius: 2rem;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.rpt-status-dot {\r\n  width: 7px;\r\n  height: 7px;\r\n  border-radius: 50%;\r\n  background: #059669;\r\n}\r\n\r\n.rpt-actions-col {\r\n  text-align: right;\r\n}\r\n\r\n.rpt-actions {\r\n  display: flex;\r\n  gap: 0.5rem;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.rpt-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n  padding: 0.45rem 0.75rem;\r\n  border: 1px solid #E2E8F0;\r\n  background: #fff;\r\n  color: #475569;\r\n  border-radius: 0.5rem;\r\n  font-family: inherit;\r\n  font-size: 0.75rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.rpt-btn:hover {\r\n  border-color: #0F766E;\r\n  color: #0F766E;\r\n  background: #F0FDF4;\r\n}\r\n\r\n.rpt-btn-download:hover {\r\n  border-color: #0D9488;\r\n  background: #F0FDF4;\r\n}\r\n\r\n.rpt-empty {\r\n  text-align: center;\r\n  color: #94A3B8;\r\n  padding: 3rem 1rem;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.rpt-empty span {\r\n  display: block;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n/* Detail modal */\r\n.rpg-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 1000;\r\n  background: rgba(15, 23, 42, 0.55);\r\n  backdrop-filter: blur(4px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 1.5rem;\r\n  animation: rpgFadeIn 0.25s ease;\r\n}\r\n\r\n.rpg-detail {\r\n  position: relative;\r\n  width: 100%;\r\n  max-width: 640px;\r\n  max-height: 90vh;\r\n  overflow-y: auto;\r\n  background: #fff;\r\n  border-radius: 1.25rem;\r\n  border: 1px solid #E2E8F0;\r\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\r\n  padding: 1.75rem;\r\n  animation: rpgSlideUp 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.rpg-detail-close {\r\n  position: absolute;\r\n  top: 0.9rem;\r\n  right: 0.9rem;\r\n  width: 34px;\r\n  height: 34px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #F1F5F9;\r\n  border: 1px solid #E2E8F0;\r\n  border-radius: 0.5rem;\r\n  color: #64748B;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.rpg-detail-close:hover {\r\n  background: #FEF2F2;\r\n  border-color: #FECACA;\r\n  color: #DC2626;\r\n}\r\n\r\n.rpg-detail-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.9rem;\r\n  padding-right: 2.5rem;\r\n  margin-bottom: 1.25rem;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.rpg-detail-icon {\r\n  width: 48px;\r\n  height: 48px;\r\n  min-width: 48px;\r\n  border-radius: 0.875rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: linear-gradient(135deg, #F0FDF4, #CCFBF1);\r\n  color: #0F766E;\r\n  border: 1px solid #99F6E4;\r\n}\r\n\r\n.rpg-detail-name {\r\n  font-size: 1.125rem;\r\n  font-weight: 700;\r\n  color: #0F172A;\r\n}\r\n\r\n.rpg-detail-meta {\r\n  font-size: 0.8125rem;\r\n  color: #64748B;\r\n}\r\n\r\n.rpg-detail-download {\r\n  margin-left: auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.45rem;\r\n  padding: 0.55rem 1rem;\r\n  background: linear-gradient(135deg, #0F766E, #0D9488);\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 0.625rem;\r\n  font-family: inherit;\r\n  font-size: 0.8125rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: opacity 0.2s, transform 0.15s;\r\n  box-shadow: 0 4px 14px rgba(15, 118, 110, 0.3);\r\n}\r\n\r\n.rpg-detail-download:hover {\r\n  opacity: 0.92;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.rpg-detail-loading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  padding: 2rem 0;\r\n  color: #64748B;\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.rpg-detail-info {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\r\n  gap: 0.75rem;\r\n  background: #F8FAFC;\r\n  border: 1px solid #E2E8F0;\r\n  border-radius: 0.75rem;\r\n  padding: 1rem;\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.rpg-info-item {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 0.6rem;\r\n  color: #0F766E;\r\n}\r\n\r\n.rpg-info-label {\r\n  font-size: 0.6875rem;\r\n  font-weight: 600;\r\n  color: #94A3B8;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n.rpg-info-val {\r\n  font-size: 0.9375rem;\r\n  font-weight: 600;\r\n  color: #0F172A;\r\n  margin-top: 0.1rem;\r\n}\r\n\r\n.rpg-detail-section-title {\r\n  font-size: 0.875rem;\r\n  font-weight: 700;\r\n  color: #0F172A;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.rpg-vitals-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\r\n  gap: 0.75rem;\r\n}\r\n\r\n.rpg-vital-item {\r\n  background: #fff;\r\n  border: 1px solid #E2E8F0;\r\n  border-radius: 0.625rem;\r\n  padding: 0.7rem 0.9rem;\r\n}\r\n\r\n.rpg-vital-label {\r\n  font-size: 0.6875rem;\r\n  font-weight: 600;\r\n  color: #94A3B8;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.04em;\r\n  margin-bottom: 0.2rem;\r\n}\r\n\r\n.rpg-vital-value {\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  color: #0F172A;\r\n}\r\n\r\n.rpg-no-vitals {\r\n  color: #94A3B8;\r\n  font-size: 0.8125rem;\r\n}\r\n\r\n@keyframes rpgFadeIn {\r\n  from { opacity: 0; }\r\n  to { opacity: 1; }\r\n}\r\n\r\n@keyframes rpgSlideUp {\r\n  from { opacity: 0; transform: translateY(16px); }\r\n  to { opacity: 1; transform: translateY(0); }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
